import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

import { computed } from 'vue'
import queryString from 'query-string'
import { cloneDeep, camelCase } from 'lodash-es'
import { useI18n } from 'vue-i18n'
import type { DcTableType } from './index'
import type { KeyString } from '@/typings/common'

const __default__ = { name: 'CustomTable' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // 表格序号
  serial: {
    type: Boolean,
    default: true
  },
  // 列描述数据对象
  columns: {
    type: Array,
    default: () => []
  },
  pagination: {
    type: [Object, Boolean],
    default: () => false
  },
  dynamicColumnSetting: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const { t } = useI18n()

const props = __props

const columnsPro = computed(() => {
  const columns = cloneDeep(props.columns)
  // 处理表格序号列
  if (props.serial) {
    columns.unshift({
      title: t('common.serial'),
      dataIndex: 'index',
      width: 65,
      fixed: 'left',
      customRender: ({ index }: { index: number }) => `${index + 1}`
    })
  }
  columns.forEach((item: any, index) => {
    // 超过宽度将自动省略，默认显示 ...
    if (item.dataIndex !== 'index' && item.dataIndex !== 'action') {
      item.ellipsis = item.ellipsis ?? true
    }
    // 时间范围格式化/固定宽度
    if (item.cosType === 'timeRange') {
      item.width = item.width ?? 345
      item.customRender = ({ column, record }: { record: any; column: DcTableType.ColumnItem }) => {
        const [start, end] = column.dataIndex as string[]
        if (!record[start] && !record[end]) return '--'
        return `${record[start]} - ${record[end]}`
      }
    }
  })
  return columns
})

/**
 * 生成跳转链接函数
 * @param column 表头配置参数
 * @param rows 行数据
 */
const linkParamsFormat = (column: DcTableType.ColumnItem, rows: KeyString): string => {
  if (column.cosType === 'link' && column.query && column.query.length) {
    const paramsObj: KeyString = {}
    column.query.forEach((item: string) => {
      if (item.indexOf('=') !== -1) {
        const [key, value] = item.split('=')
        if (value.indexOf('$') !== -1) {
          paramsObj[key] = rows[value.replace('$', '')]
        } else {
          paramsObj[key] = value
        }
      } else if (item.indexOf('.') !== -1) {
        const keyList = item.split('.')
        const objKey = camelCase(keyList.join('_'))
        const objVal = keyList.reduce((objRow: any, currentKey: string) => objRow && objRow[currentKey], rows)
        paramsObj[objKey] = objVal
      } else {
        paramsObj[item] = rows[item]
      }
    })
    return `${column.path}?${queryString.stringify(paramsObj)}`
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_table = _resolveComponent("dc-table")!

  return (_openBlock(), _createBlock(_component_dc_table, _mergeProps({
    class: "custom-table ant-table-striped",
    size: "small",
    dynamicColumnSetting: __props.dynamicColumnSetting,
    pagination: __props.pagination,
    outsidePagination: true,
    columns: columnsPro.value
  }, _ctx.$attrs), {
    headerCell: _withCtx(({ title, column }) => [
      _renderSlot(_ctx.$slots, "headerCell", {
        title: title,
        column: column
      })
    ]),
    bodyCell: _withCtx(({ text, record, index, column }) => [
      (column.cosType === 'link')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: linkParamsFormat(column, record),
            title: text
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(text || '--'), 1)
            ]),
            _: 2
          }, 1032, ["to", "title"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "bodyCell", {
        text: text,
        record: record,
        index: index,
        column: column
      })
    ]),
    _: 3
  }, 16, ["dynamicColumnSetting", "pagination", "columns"]))
}
}

})